"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = translate;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const defaultDb = "TOP";
function translate(texts, textDefinition, showTextDb, showWithTextId) {
    var _a;
    const getStaticTextTranslation = (textKey, textDb) => getStaticText(texts, textKey, textDb, showTextDb, showWithTextId);
    switch (textDefinition.type) {
        case "LanguageIdText":
            return getStaticTextTranslation(textDefinition.languageId);
        case "StaticText":
            return getStaticTextTranslation(textDefinition.textId, (_a = textDefinition.systemTypeId) === null || _a === void 0 ? void 0 : _a.substring(0, 3).toUpperCase());
        case "CurlyText":
            return getCurlyText(texts, textDefinition.text, textDefinition.systemTypeId, showTextDb, showWithTextId);
        case "StaticTextWithParameters": {
            return getStaticTextWithParameters(texts, textDefinition.textId, textDefinition.parameters);
        }
        case "SystemIdText":
            return getStaticTextTranslation(textDefinition.systemId, textDefinition.systemId.toUpperCase());
        case "TabTitleText":
            return getStaticTextTranslation(textDefinition.key);
        case "ProductText":
            return getStaticTextTranslation(textDefinition.productId, textDefinition.productId.substring(0, 3).toUpperCase());
        case "ProductPropertyText": {
            const systemTypeId = textDefinition.productId.substring(0, 3);
            const key = `p_${systemTypeId}_${textDefinition.propertyName}`;
            return getStaticTextTranslation(key, systemTypeId.toUpperCase());
        }
        case "ProductPropertyValueText": {
            const systemTypeId = textDefinition.productId.substring(0, 3);
            const key = `p_${systemTypeId}_${textDefinition.propertyName}_${textDefinition.propertyValue}`;
            return getStaticTextTranslation(key, systemTypeId.toUpperCase());
        }
        case "SystemTypePropertyText": {
            const key = `p_${textDefinition.systemTypeId.toLowerCase()}_${textDefinition.propertyName}`;
            return getStaticTextTranslation(key, textDefinition.systemTypeId.toUpperCase());
        }
        case "SystemTypePropertyValueText": {
            const key = `p_${textDefinition.systemTypeId.toLowerCase()}_${textDefinition.propertyName}_${textDefinition.propertyValue}`;
            return getStaticTextTranslation(key, textDefinition.systemTypeId.toUpperCase());
        }
        case "TranslateTodoText":
            return `{${textDefinition.textId}}`;
        case "ReportParamText": {
            const key = `rp_${textDefinition.paramName}`;
            return getStaticTextTranslation(key, textDefinition.systemTypeId);
        }
        case "ReportParamValueText": {
            const key = `rp_${textDefinition.paramName}_${textDefinition.paramValue}`;
            return getStaticTextTranslation(key, textDefinition.systemTypeId);
        }
        default:
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(textDefinition, true);
    }
}
function fallBackTextDb(texts, textId, showTextDb) {
    const db = texts[defaultDb] || {};
    const text = db[textId.toLowerCase()];
    if (!text) {
        return undefined;
    }
    return `${text} ${showTextDb ? "(FALLBACK)" : ""}`;
}
function fromSystemTypeDB(texts, textId, textDB, showTextDb) {
    const db = texts[textDB] || {};
    const text = db[textId.toLowerCase()];
    if (!text) {
        return undefined;
    }
    if (textDB === defaultDb) {
        return `${text} ${showTextDb ? "(TOP)" : ""}`;
    }
    return `${text} ${showTextDb ? "(SYSTEMDB)" : ""}`;
    return text + "(SYSTEMDB)";
}
function getStaticText(texts, textId, textDb = defaultDb, showTextDb, showWithTextId) {
    const textIdStringified = `{${textId}}`;
    if (showWithTextId) {
        const translatedText = fromSystemTypeDB(texts, textId, textDb, showTextDb) ||
            fallBackTextDb(texts, textId, showTextDb);
        if (translatedText) {
            return translatedText + textIdStringified;
        }
        return textIdStringified;
    }
    return (fromSystemTypeDB(texts, textId, textDb, showTextDb) ||
        fallBackTextDb(texts, textId, showTextDb) ||
        textIdStringified);
}
function getStaticTextWithParameters(texts, textId, parameters) {
    const textDb = texts[defaultDb] || {};
    const text = textDb[textId.toLowerCase()];
    if (!text) {
        return `{${textId}}`;
    }
    return parameters.reduce((soFar, current, ix) => soFar.replace(`{${ix}}`, current), text);
}
const curlyRegex = /\{(.+?)\}/g;
function getCurlyText(texts, textKey, textDb, showTextDb, showWithTextId) {
    const translated = textKey.replace(curlyRegex, (_, group1) => getStaticText(texts, group1, textDb, showTextDb, showWithTextId));
    return translated;
}
//# sourceMappingURL=translator.js.map